export default __webpack_public_path__ + "static/media/Conflict of Interest Management Policy Sept 2024.bf45a8bd.pdf";